module.exports = __webpack_public_path__ + "static/media/02_Palex_ConClaim_Color.3c8b18c1.svg";